import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const informationPageInvoiceHistorySectionK = {
  currency: "information_page_invoice_history_section.currency",
  project: "information_page_invoice_history_section.project",
  invoiceNo: "information_page_invoice_history_section.invoiceNo",
  toDate: "information_page_invoice_history_section.toDate",
  productDescription: "information_page_invoice_history_section.productDescription",
  fromDate: "information_page_invoice_history_section.fromDate",
  invoiceDate: "information_page_invoice_history_section.invoiceDate",
  productType: "information_page_invoice_history_section.productType",
  contactPerson: "information_page_invoice_history_section.contactPerson",
  totalAmount: "information_page_invoice_history_section.totalAmount",
  accountType: "information_page_invoice_history_section.accountType",
  productNumber: "information_page_invoice_history_section.productNumber",
  description: "information_page_invoice_history_section.description",
  hasCreditNote: "information_page_invoice_history_section.hasCreditNote",
  document: "information_page_invoice_history_section.document",
  searchFieldPlaceholder: "information_page_invoice_history_section.searchFieldPlaceholder",
  quantity: "information_page_invoice_history_section.quantity",
  invoiceLines: "information_page_invoice_history_section.invoiceLines",
  orderNo: "information_page_invoice_history_section.orderNo",
  pastDueBalance: "information_page_invoice_history_section.pastDueBalance",
};

export const useInformationPageInvoiceHistorySectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      currency: t(informationPageInvoiceHistorySectionK.currency),
      project: t(informationPageInvoiceHistorySectionK.project),
      invoiceNo: t(informationPageInvoiceHistorySectionK.invoiceNo),
      toDate: t(informationPageInvoiceHistorySectionK.toDate),
      productDescription: t(informationPageInvoiceHistorySectionK.productDescription),
      fromDate: t(informationPageInvoiceHistorySectionK.fromDate),
      invoiceDate: t(informationPageInvoiceHistorySectionK.invoiceDate),
      productType: t(informationPageInvoiceHistorySectionK.productType),
      contactPerson: t(informationPageInvoiceHistorySectionK.contactPerson),
      totalAmount: t(informationPageInvoiceHistorySectionK.totalAmount),
      accountType: t(informationPageInvoiceHistorySectionK.accountType),
      productNumber: t(informationPageInvoiceHistorySectionK.productNumber),
      description: t(informationPageInvoiceHistorySectionK.description),
      hasCreditNote: t(informationPageInvoiceHistorySectionK.hasCreditNote),
      document: t(informationPageInvoiceHistorySectionK.document),
      searchFieldPlaceholder: t(informationPageInvoiceHistorySectionK.searchFieldPlaceholder),
      quantity: t(informationPageInvoiceHistorySectionK.quantity),
      invoiceLines: t(informationPageInvoiceHistorySectionK.invoiceLines),
      orderNo: t(informationPageInvoiceHistorySectionK.orderNo),
      pastDueBalance: t(informationPageInvoiceHistorySectionK.pastDueBalance),
    }),
    [i18n.language]
  );
};